import { Component, OnInit } from '@angular/core';
import { NgForOf, NgIf, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Icons } from '../../model/icon';
import { IconComponent } from '../elements/icon/icon.component';
import {HeaderModalComponent} from './header-modal/header-modal.component';
import { LanguageService } from '../../services/language.service';
import { HostListener } from '@angular/core';
import { CurrencyService, CurrencyCode } from '../../services/currency.service';
import { BookingService } from '../../services/booking2.service';

@Component({
  selector: 'app-header',
  imports: [
    NgForOf,
    NgIf,
    IconComponent,
    HeaderModalComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  Icons = Icons;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public languageService: LanguageService,
    public currencyService: CurrencyService,
    public booking: BookingService
  ) {}

  isCurrencyDropdownOpen = false;

  menuElements: any[][] = [
    [
      {
        title: ['Hotels', 'Отели'],
        url: 'https://ilovefirstclass.sit-co.ru/',
      },
      {
        title: ['Contact', 'Контакты'],
        url: '/contact-us',
      },
      {
        title: ['About', 'О нас'],
        url: '/about',
      },
     // {
     //   title: 'live chat',
     //   url: '/chat',
     // },
    ],
    [
      {
        label: '$'
      },
      {
        icon: Icons.cart
      },
      // {
      //  icon: Icons.lk,
      // }
    ]
  ];

  isModalOpen = false;

  ngOnInit() {
    this.checkUrl();
  }

  goTo(url: string) {
    this.router.navigate([url]).then(r => r);
  }

  checkUrl() {
    const currentPath = this.location.path();
    return currentPath === '/change-airport' || currentPath === '/add-airport';
  }

  isAirportPageColor() {
    const route = this.route.snapshot.firstChild;
    const currentPath = this.location.path();
    if (currentPath === '/contact-us' || currentPath === '/add-airport' || currentPath === '/change-airport'|| currentPath === '/success' || currentPath === '/about') {
      return 'color: black; background: white';
    }

    if (window.location.pathname.startsWith('/airport/')) {
      return 'color: black; background: white'
    }
    if (window.location.pathname.startsWith('/airport-detail/')) {
      return 'color: black; background: white'
    }
    if (window.location.pathname.startsWith('/airport-booking2/')) {
      return 'color: black; background: white'
    }
    if (window.location.pathname.startsWith('/success/')) {
      return 'color: black; background: white'
    }
    if (window.location.pathname.startsWith('/checkout')) {
      return 'color: black; background: white'
    }

    if (currentPath === '/chat' || currentPath === '/admin') {
      return 'color: black; background: white'
    }

    else {
      return 'color: white;'
    }
  }

  isAirportPageInvert() {
    const route = this.route.snapshot.firstChild;
    const currentPath = this.location.path();
    if (currentPath === '/contact-us' || currentPath === '/add-airport' || currentPath === '/change-airport' || currentPath === '/success' || currentPath === '/about') {
      return true;
    }
    if (currentPath.startsWith('/airport-detail/')) {
      return true;
    }
    if (currentPath.startsWith('/airport-booking2/')) {
      return true;
    }
    if (currentPath.startsWith('/checkout')) {
      return true;
    }
    if (currentPath.startsWith('/success/')) {
      return true;
    }

    if (currentPath === '/chat' || currentPath === '/admin') {
      return true
    }

    return window.location.pathname.startsWith('/airport/');
  }
  openUrl(url: string): void {
    if (!url) return;

    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    this.router.navigate([url]).then();
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  toggleLanguage(): void {
    this.languageService.toggleLanguage();
  }

  getLanguageLabel(): string {
    return this.languageService.currentLanguage === 'en' ? 'Eng' : 'Ru';
  }

  toggleCurrencyDropdown(): void {
    this.isCurrencyDropdownOpen = !this.isCurrencyDropdownOpen;
  }

  selectCurrency(code: CurrencyCode): void {
    this.currencyService.setCurrency(code);
    this.isCurrencyDropdownOpen = false;
  }

  isMobileMenuOpen = false;

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.currency-switcher')) {
      this.isCurrencyDropdownOpen = false;
    }
  }

}
